(function () {
  "use strict";

  const cfg = window.bundlerOverlayConfig || {};
  const vps = window.volumePricingStrings || {};
  const titleText = cfg.titleText || vps.savingsTitle || "Koop meer en bespaar!";
  const perUnitTemplate = cfg.perUnitTemplate || "€{price} per stuk";
  // vps.savings uses a [discount] placeholder; this overlay templates with {discount}.
  const savingsTemplate = cfg.savingsTemplate || (vps.savings ? vps.savings.replace("[discount]", "{discount}") : "bespaar {discount}%");

  function formatPriceNl(cents) {
    const v = (cents / 100).toFixed(2).replace(".", ",");
    return v;
  }

  function getBaseVariantPriceCents() {
    // 1. Prefer the size-grid cells (they carry data-unit-price set after product.js loads)
    const cell = document.querySelector("[data-size-qty][data-unit-price]");
    if (cell) {
      const v = parseInt(cell.getAttribute("data-unit-price"), 10);
      if (!isNaN(v) && v > 0) return v;
    }
    // 2. Try parsing the totaal card price display
    const priceEl = document.querySelector("[data-size-grid-price]");
    if (priceEl && priceEl.textContent) {
      const txt = priceEl.textContent.replace(/[^\d,]/g, "").replace(",", ".");
      const v = parseFloat(txt);
      if (!isNaN(v) && v > 0) return Math.round(v * 100);
    }
    return null;
  }

  function applyOverlay() {
    const containers = document.querySelectorAll(".bndlr-volume");
    if (containers.length === 0) return false;

    const basePriceCents = getBaseVariantPriceCents();

    containers.forEach(function (container) {
      // Title
      const titleEl = container.querySelector(".bndlr-volume-title");
      if (titleEl && titleEl.textContent.trim() !== titleText) {
        titleEl.textContent = titleText;
      }
      // Hide description (already hidden via CSS but make sure)
      const descEl = container.querySelector(".bndlr-volume-description");
      if (descEl && descEl.style.display !== "none")
        descEl.style.display = "none";

      // Each tier row
      const rows = container.querySelectorAll(
        ".bndlr-volume-discount[data-quantity]",
      );
      rows.forEach(function (row) {
        const savingEl = row.querySelector(".bndlr-volume-saving-text");
        let discountPct = null;
        if (savingEl) {
          const m = (savingEl.textContent || "").match(/(\d+(?:[.,]\d+)?)\s*%/);
          if (m) discountPct = parseFloat(m[1].replace(",", "."));
        }

        // Per-unit price
        const priceEl = row.querySelector(".bndlr-volume-variant-price");
        if (priceEl && basePriceCents != null && discountPct != null) {
          const perCents = Math.round(basePriceCents * (1 - discountPct / 100));
          const formatted = perUnitTemplate.replace(
            "{price}",
            formatPriceNl(perCents),
          );
          if (priceEl.textContent.trim() !== formatted) {
            priceEl.textContent = formatted;
          }
        }

        // Rewrite savings text
        if (savingEl && discountPct != null) {
          // Show whole-number percentages cleanly (drop trailing zeros)
          const pctDisplay =
            discountPct % 1 === 0
              ? discountPct.toString()
              : discountPct.toString().replace(".", ",");
          const formatted = savingsTemplate.replace("{discount}", pctDisplay);
          if (savingEl.textContent.trim() !== formatted) {
            savingEl.textContent = formatted;
          }
        }
      });
    });

    return true;
  }

  function init() {
    document.addEventListener("bundler:loaded", applyOverlay);
    document.addEventListener("bundler:rendered", applyOverlay);
    // Re-apply when the size-grid finishes loading product data (so the per-stuk price can be calculated)
    document.addEventListener("size-grid:change", applyOverlay);

    if (applyOverlay()) return;
    let tries = 0;
    const interval = setInterval(function () {
      tries++;
      applyOverlay();
      if (tries > 60) clearInterval(interval);
    }, 300);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
